import styled from 'styled-components';

export const Heading1Styled = styled.span`
  font-family: mercury display;
  font-size: 40px;
  font-style: normal;
  font-weight: 500;
  line-height: 110%;
`;
